// imports
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '../constants';
import GameLayout from '../layouts/game';
import TabView from '../molecules/tabView';
import HeroList from '../molecules/list/hero';
import { HeroNFT } from '../repositories/web3/types';
import { HeroListFilter as Filter } from '../common/types';
import TraitDetailTooltip from '../atoms/tooltip/traitDetail';
import HeroDetailView from '../molecules/tabView/sidebar/heroDetailView';
import { selectConfig, selectUIMap } from '../repositories/store/slices';

// exports
export default function Heroes(): JSX.Element {
  // hooks configuration
  const navigate = useNavigate();
  const { world } = useSelector(selectConfig);
  const { currRegion: { id: currRegionId } } = useSelector(selectUIMap);
  const [state, setState] = useState<{ hero?: HeroNFT; filter: Filter }>({ hero: undefined, filter: 'all' });
  const traitIds = state.hero?.traitIds || undefined;
  // private methods / components
  const heroClickedCB = (hero: HeroNFT | undefined, filter: Filter): void => { setState({ hero, filter }); };
  const heroDetailView = <HeroDetailView hero={state.hero} filter={state.filter} />;
  // render
  return (
    <GameLayout backBtnClickedCB={() => navigate(ROUTES.GAME)} backButtonText={currRegionId ? world.regions[currRegionId].name : ''}>
      <TabView sidebar={heroDetailView}>
        <HeroList selectedHero={state.hero} heroClickedCB={heroClickedCB} filterChangedCB={heroClickedCB} />
        <div>{traitIds?.map((trait) => <div key={trait}><TraitDetailTooltip anchorSelect={`#${trait}`} traitId={trait || ''} /></div>)}</div>
      </TabView>
    </GameLayout>
  );
}
